// 是否小数点
const regDot = new RegExp(/^\d+\.\d+$/)
// 数字
const regNumber = new RegExp(
  /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
)
//  身份证正则
export const regCardNo = new RegExp(
  /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
)

const applyFormLegalValidate = {
  //   姓名
  contactName: [
    { required: true, message: '请输入融资经办人姓名', trigger: 'blur' },
    { pattern: /^([\u4e00-\u9fa5·]{2,20})$/, message: '姓名格式错误', trigger: 'blur' }
  ],
  //   身份证
  cardNo: [
    { required: true, message: '请输入融资经办人身份证号', trigger: 'blur' },
    { pattern: regCardNo, message: '身份证格式错误', trigger: 'blur' }
  ],
  //   手机号
  contactPhone: [
    { required: true, message: '请输入融资经办人手机号', trigger: 'blur' },
    { pattern: /^1[3-9]\d{9}$/, message: '手机号格式错误', trigger: 'blur' }
  ]
}
const applyFormPersonValidate = {
  //   公司名
  enterpriseName: [
    { required: true, message: '请正确输入企业名称', trigger: 'blur' },
    { pattern: /^[\u4e00-\u9fa5·()（）]+$/, message: '企业名称格式错误', trigger: 'blur' }
  ],
  //   统一社会信用代码
  uniscid: [{ required: true, message: '请正确输入企业名称', trigger: 'blur' }],
  //   申请人姓名
  contactName: [{ required: true, message: ' ', trigger: 'blur' }],
  //   申请人手机号
  contactPhone: [{ required: true, message: ' ', trigger: 'blur' }],
  //   关联关系
  applicantEnterpriseRelationship: [
    { required: true, message: '请选择申请人与企业关联关系', trigger: 'blur' }
  ],
  //   共同申请人姓名
  hasJointApplicant: [{ required: true, message: '请选择是否有共同申请人', trigger: 'blur' }],
  jointApplicantName: [
    { required: true, message: '请输入共同申请人姓名', trigger: 'blur' },
    { pattern: /^([\u4e00-\u9fa5·]{2,20})$/, message: '姓名格式错误', trigger: 'blur' }
  ],
  //   共同申请人身份证
  jointApplicantCardNo: [
    { required: true, message: '请输入共同申请人身份证', trigger: 'blur' },
    {
      pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
      message: '身份证格式错误',
      trigger: 'blur'
    }
  ],
  //   共同申请人手机号
  jointApplicantMobile: [
    { required: true, message: '请输入共同申请人手机号', trigger: 'blur' },
    { pattern: /^1[3-9]\d{9}$/, message: '手机号格式错误', trigger: 'blur' }
  ]
}

const applyFormValidate = {
  //   经营地址
  businessLocation: [{ required: true, message: '请选择经营地址', trigger: 'change' }],
  //   详细地址
  operateArea: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
  //   融资金额
  applyFinancingAmount: [
    { required: true, message: '请输入融资金额', trigger: 'blur' },
    {
      trigger: 'blur',
      validator(rule, value, callBack) {
        if (!regNumber.test(value) || regDot.test(value) || value < 1) {
          callBack(new Error('融资金额格式错误'))
        } else {
          callBack()
        }
      }
    }
  ],
  //   融资期限
  termRange: [{ required: true, message: '请选择融资期限', trigger: 'change' }],
  timeLimit: [
    { required: true, message: '请输入融资期限', trigger: 'blur' },
    {
      trigger: 'blur',
      validator(rule, value, callBack) {
        if (!regNumber.test(value) || regDot.test(value) || value < 1) {
          callBack(new Error('融资期限格式错误'))
        } else {
          callBack()
        }
      }
    }
  ],
  //   融资类型
  financingCategory: [
    {
      required: true,
      trigger: 'change',
      validator(rule, value, callBack) {
        if (value === undefined || value === '') {
          callBack(new Error('请选择融资类型'))
        } else {
          callBack()
        }
      }
    }
  ],
  //   资金用途
  loanUse: [{ required: true, message: '请输入资金用途', trigger: 'blur' }],
  //   担保方式
  guaranteeMeans: [{ required: true, message: '请选择担保方式', trigger: 'change' }]
}

const productFormValidate = {
  // 机构
  curSelectedOrg: [{ required: true, message: '请选择机构', trigger: 'change' }]
}

function validateApplySituation(productDetail, form) {
  if (productDetail.quotaRangeEnd < form.applyFinancingAmount) {
    return "该产品的'贷款额度'与您的融资需求不匹配，请输入该产品额度范围内的金额或更换其他产品"
  }
  if (
    (Number(form.termRange) === -1 && productDetail.termRangeStart > form.timeLimit) ||
    productDetail.termRangeEnd < form.timeLimit
  ) {
    return "该产品的'贷款期限'与您的融资需求不匹配，请输入该产品贷款期限内的时间或更换其他产品"
  }
  return true
}

export {
  applyFormLegalValidate,
  applyFormPersonValidate,
  applyFormValidate,
  productFormValidate,
  validateApplySituation
}
